/**
 * @generated SignedSource<<4b780920ff7703793eb94ddcec2df723>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ChargeViewInput = {
  clientMutationId?: string | null | undefined;
  id: string;
  medium: string;
};
export type ChargeViewMutation$variables = {
  input: ChargeViewInput;
};
export type ChargeViewMutation$data = {
  readonly ChargeView: {
    readonly error: string | null | undefined;
    readonly success: string | null | undefined;
  } | null | undefined;
};
export type ChargeViewMutation = {
  response: ChargeViewMutation$data;
  variables: ChargeViewMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ChargeViewPayload",
    "kind": "LinkedField",
    "name": "ChargeView",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ChargeViewMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ChargeViewMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "355b3aac34a0e4a25643a2e031ad46c3",
    "id": null,
    "metadata": {},
    "name": "ChargeViewMutation",
    "operationKind": "mutation",
    "text": "mutation ChargeViewMutation(\n  $input: ChargeViewInput!\n) {\n  ChargeView(input: $input) {\n    success\n    error\n  }\n}\n"
  }
};
})();

(node as any).hash = "ba92deb4b41d051de163e751b6d72722";

export default node;
